jQuery(document).ready(function(){
  
/*  if(jQuery('body').hasClass('collection')){
    var col_handle = jQuery('body').attr('data-colHandle');  
    var b = 0;
    $(window).on( 'scroll' , function() {      
      b = jQuery(this).scrollTop();	   	      
    });
    setInterval(function() {
      var date = new Date();       
      date.setTime(date.getTime() + (60 * 60 * 1000 * 24 * 5));
      $.cookie(col_handle, b, { path: "/", expires: date});       
    }, 300);          
  }    */
});
/*
jQuery(window).load(function(){
  setTimeout(function(){
    if(jQuery('body').hasClass('collection')){
      var col_handle = jQuery('body').attr('data-colHandle');  
      if($.cookie(col_handle)){
        var scroll_pos = $.cookie(col_handle);
        $(window).scrollTop(scroll_pos);
      }
    }
  }, 2500);
}); */